import * as React from 'react'
import { ENTITY_TYPES, SOLD_SERVICE_STATUS } from '@sales-center/common'
import { CloseWonErrorDialog } from '../../CloseWonErrorDialog/CloseWonErrorDialog'
import { SoldServicesDrawer } from '../../SoldServicesDrawer'
import { SOLD_SERVICES_CONTENT_MODE } from '../../SoldServicesDrawer/SoldServicesContent/typings'
import { ClosedLostReasonsDialog } from '@user/components/ClosedLostReasonsDialog'
import { ClosedWonLostMenu } from '../OpportunityProgressWidget/ClosedWonLostMenu/ClosedWonLostMenu'
import { useData } from './hooks/useData'
import { useHandlers } from './hooks/useHandlers'
import { SelectStyled } from '@sales-center/components'
import { OPPORTUNITY_STATUSES, OppStatus } from '../typings'
import Stack from '@mui/material/Stack'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'

export type Props = {
  disabled?: boolean
  oppStatus: OppStatus
  opportunityId: number
  salesFunnelId: number
  externalSvcLocId: string
  salesFunnelStageId: number
  assigneeId: string | null
  soldServiceStatus: SOLD_SERVICE_STATUS
}

export function OpportunityStatusSelect(props: Props) {
  const {
    oppStatus,
    salesFunnelId,
    opportunityId,
    externalSvcLocId,
    salesFunnelStageId,
    assigneeId,
  } = props

  const {
    anchorEl,
    onChange,
    onCloseWin,
    setAnchorEl,
    wonLostMenuOpen,
    handleClosedLostMenuItemClick,
    handleClosedWonMenuItemClick,
  } = useHandlers(props)

  const { closedWonStageId, disabled, salesFunnelStages, lockedStageId } =
    useData(props)

  return (
    <Stack>
      <FormControl>
        <SelectStyled
          select
          disabled={disabled}
          onChange={onChange}
          variant="outlined"
          value={salesFunnelStageId.toString()}
          fullWidth
          label="Opportunity Stage"
          size="small"
          data-test-id={`opportunity-status-select-${opportunityId}`}
        >
          {salesFunnelStages.map((stage) => (
            <MenuItem
              key={stage.id}
              style={{ fontSize: '14px' }}
              value={stage.id}
              disabled={stage.id === lockedStageId}
            >
              {stage.name}
            </MenuItem>
          ))}
        </SelectStyled>
      </FormControl>

      {/* ========== C L O S E D   W O N / L O S T   M E N U ========== */}
      <ClosedWonLostMenu
        open={wonLostMenuOpen}
        onClose={() => setAnchorEl(null)}
        onClosedLostClick={handleClosedLostMenuItemClick}
        onClosedWonClick={handleClosedWonMenuItemClick}
        opportunityId={opportunityId}
        anchorEl={anchorEl}
      />

      {/* ========== C L O S E D   L O S T   R E A S O N S   D I A L O G ========== */}
      <ClosedLostReasonsDialog
        entityId={opportunityId}
        salesFunnelId={salesFunnelId}
        entityType={ENTITY_TYPES.Opportunity}
        assigneeId={assigneeId}
        soldServiceStatus={props.soldServiceStatus}
      />

      {/* ========== C L O S E / W I N   E R R O R   P O P U P ========== */}
      <CloseWonErrorDialog
        opportunityId={opportunityId}
        salesFunnelId={salesFunnelId}
      />

      <SoldServicesDrawer
        onCloseWin={onCloseWin}
        entityId={opportunityId}
        externalSvcLocId={externalSvcLocId}
        closedWonStageId={closedWonStageId}
        entityType={ENTITY_TYPES.Opportunity}
        type={SOLD_SERVICES_CONTENT_MODE.EditOpp}
        readonly={oppStatus !== OPPORTUNITY_STATUSES.Open}
      />
    </Stack>
  )
}
